import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserList } from './Views/User/UserList';
import { UserForm } from './Views/User/UserForm';
import { SecurityLog } from './Views/SecurityLog/SecurityLog';
import { NavBar } from './Component/NavBar/NavBar';
import { SignIn } from './Views/LogIn/LogIn';
import { Home } from './Views/home/home';
import { UniversityList } from './Views/University/UniversityList';
import { UniversityForm } from './Views/University/UniversityForm';
import { ProgramList } from './Views/Program/ProgramList';
import { ProgramForm } from './Views/Program/ProgramForm';
import { LeadList } from './Views/Lead/LeadList';
import { HomePageForm } from './Views/HomeContent/HomePageForm';

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<SignIn />}></Route>
        <Route path="/home" element={<NavBar><Home /></NavBar>}></Route>
        <Route path="/DashBoard" element={<NavBar><Home /></NavBar>}></Route>
        <Route path="/HomePageContent" element={<NavBar><HomePageForm /></NavBar>} />
        <Route path="/UserList" element={<NavBar><UserList /> </NavBar>} />
        <Route path="/Logs" element={<NavBar><SecurityLog /></NavBar>} />
        <Route path="/UserForm" element={<NavBar><UserForm /></NavBar>} />
        <Route path="/UserForm/:id" element={<NavBar><UserForm /></NavBar>} />
        <Route path="/UniversityList" element={<NavBar><UniversityList /></NavBar>} />
        <Route path="/UniversityForm" element={<NavBar><UniversityForm /></NavBar>} />
        <Route path="/UniversityForm/:id" element={<NavBar><UniversityForm /></NavBar>} />
        <Route path="/ProgramList" element={<NavBar><ProgramList /></NavBar>} />
        <Route path="/ProgramForm" element={<NavBar><ProgramForm /></NavBar>} />
        <Route path="/ProgramForm/:id" element={<NavBar><ProgramForm /></NavBar>} />
        <Route path="/LeadList" element={<NavBar><LeadList /></NavBar>} />
        <Route path="*" element={<h1>No Page Found</h1>} />
      </Routes>
    </BrowserRouter>


  );
}

export default App;
